import React from 'react';
import moment from 'moment';

import { Grid, Typography } from '@material-ui/core';
import { TextField, CheckField, DateField, ImageField, AddressField, Step } from '../SteppedForm';

import rules from './rules';

const StepPlateprovider = (props) => {
  return (
    <Step
      id="plateprovider"
      title={
        'Vehicle - ' + (props.stateconfig().authName || props.stateconfig().plateName) + ' Owner'
      }
      skip={(formdata) =>
        formdata.vehicles[props.state.vehicle_index].plateOwnership !== 'other' ||
        formdata.onboardcar === false ||
        props.stateconfig().onlyownplate ||
        props.stateconfig().noplates ||
        formdata.tiger === true
      }
      valid={{
        valid: () =>
          !props.stateconfig().appointmentbyowner ||
          props.getVehicle().appointmentbyowner_later ||
          props.getVehicle().appointmentbyowner,
        msg: 'Must provide either Appointment by Owner, or indicate you will provide it later'
      }}>
      {props.stateconfig().plate && (
        <div>
          <Typography variant="body1">
            Details of the Person/Company providing you with your Taxi{' '}
            {props.stateconfig().plateName}?
          </Typography>
          <Grid container>
            <Grid item xs={12} lg={6}>
              <TextField
                id="plate_number"
                label={props.stateconfig().plateName + ' #'}
                modify={(value) => props.toUpperCase(value)}
                required
              />
            </Grid>
            {!props.stateconfig().plateExpiry && (
              <Grid item xs={12} lg={6}>
                <DateField
                  id="plate_exp"
                  label={props.stateconfig().plateName + ' Expiry'}
                  maxDate={
                    props.stateconfig().plateMaxDate
                      ? moment().add(props.stateconfig().plateMaxDate, 'months')
                      : undefined
                  }
                  minDate={moment()}
                  required
                />
              </Grid>
            )}
            <Grid item xs={12} lg={6}>
              <TextField
                id="plate_owner_name"
                label={props.stateconfig().plateName + ' Owner Name'}
                required
              />
            </Grid>
            <Grid item xs={12} lg={6}>
              <TextField
                id="plate_owner_acn_abn"
                label="ABN/ACN (Without Spaces)"
                valid={rules.numeric}
                modify={(value) => props.limitLength(value, 11)}
                required
              />
            </Grid>
            <Grid item xs={12} lg={6}>
              <AddressField id="plate_address" label="Address" required country="AU" fetchDetails />
            </Grid>
          </Grid>
        </div>
      )}

      {props.stateconfig().auth && (
        <div>
          <Typography variant="body1" class="formQuestion">
            Details of the Person/Company providing you with your Taxi{' '}
            {props.stateconfig().authName}?
          </Typography>
          <Grid container>
            <Grid item xs={12} lg={6}>
              <TextField
                id="auth_number"
                label={props.stateconfig().authName + ' #'}
                modify={(value) => props.toUpperCase(value)}
                required
              />
            </Grid>
            {!props.stateconfig().authExpiry && (
              <Grid item xs={12} lg={6}>
                <DateField
                  id="auth_exp"
                  label={props.stateconfig().authName + ' Expiry'}
                  maxDate={
                    props.stateconfig().authMaxDate
                      ? moment().add(props.stateconfig().authMaxDate, 'months')
                      : undefined
                  }
                  minDate={moment()}
                  required
                />
              </Grid>
            )}
            <Grid item xs={12} lg={6}>
              <TextField
                id="auth_owner_name"
                label={props.stateconfig().authName + ' Owner Name'}
                required
              />
            </Grid>
            <Grid item xs={12} lg={6}>
              <TextField
                id="auth_owner_acn_abn"
                label="ABN/ACN (Without Spaces)"
                valid={rules.numeric}
                modify={(value) => props.limitLength(value, 11)}
                required
              />
            </Grid>
            <Grid item xs={12} lg={6}>
              <AddressField id="auth_address" label="Address" required country="AU" fetchDetails />
            </Grid>
          </Grid>
        </div>
      )}

      {props.stateconfig().appointmentbyowner && (
        <>
          {!props.getVehicle().appointmentbyowner_later && (
            <ImageField
              id="appointmentbyowner"
              label="Appointment by Owner"
              height={192}
              width={128}
              min_filesize={1000}
              max_filesize={5242880}
              acceptAll
            />
          )}
          <CheckField
            id="appointmentbyowner_later"
            label="I will provide an Appointment by Owner document later"
          />
        </>
      )}

      {props.stateconfig().plate && (
        <div>
          <CheckField id="plate_gst" label="Registered for GST" />
        </div>
      )}

      {props.stateconfig().auth && (
        <div>
          <CheckField id="auth_gst" label="Registered for GST" />
        </div>
      )}
    </Step>
  );
};

export default StepPlateprovider;
